export enum SeverityType{
    Normal=1, 
    BorderlineProblem=2,
    ModerateProblem=4,
    MildProblem=3,
    MarkedProblem=5,
    SevereProblem=6,
    MostExtremeProblem=7
}